// Tiny attribution footer rendered at the bottom of every Sacristy
// AI surface — both authenticated (dashboard, settings, modals' parent
// pages) and the unauthenticated parish help center. The parish wears
// the brand; Sacristy AI is acknowledged in the margin.
export default function PoweredByFooter() {
  return (
    <footer className="powered-by">
      <p>
        Powered by{" "}
        <a href="https://sacristyai.com" target="_blank" rel="noreferrer">
          Sacristy AI
        </a>
      </p>
    </footer>
  );
}
